import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { AVAILABLE_COLUMNS } from '../history.available-columns';
import { HistoryActions } from 'src/app/state/history/actions';

@Component({
  selector: 'columns-menu',
  templateUrl: './columns-menu.component.html',
  styleUrls: ['./columns-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnsMenuComponent {

  @Select(state => state.history.history.displayColumns) displayColumns;
  availableColumns = AVAILABLE_COLUMNS;
  colsMenuOpen = new BehaviorSubject(false);

  constructor(
    private store: Store
  ) {}

  toggle(col) {
    console.log(col);
    this.store.dispatch(new HistoryActions.ToggleDisplayColumn(col));
  }
}
